
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'persistent-answer-field',

	data() {
		return {
			text: '' as string
		};
	},

	methods: {
		inputValue() {
			this.$emit('input-value', this.text);

			this.text = '';
		}
	}
});
